/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtifactWidgetCmaDetailsContent
 */
export interface ArtifactWidgetCmaDetailsContent {
    /**
     * Originating artifact's id.
     * @type {string}
     * @memberof ArtifactWidgetCmaDetailsContent
     */
    artifactId?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetCmaDetailsContent
     */
    cmaId: string;
}

/**
 * Check if a given object implements the ArtifactWidgetCmaDetailsContent interface.
 */
export function instanceOfArtifactWidgetCmaDetailsContent(value: object): value is ArtifactWidgetCmaDetailsContent {
    if (!('cmaId' in value) || value['cmaId'] === undefined) return false;
    return true;
}

export function ArtifactWidgetCmaDetailsContentFromJSON(json: any): ArtifactWidgetCmaDetailsContent {
    return ArtifactWidgetCmaDetailsContentFromJSONTyped(json, false);
}

export function ArtifactWidgetCmaDetailsContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactWidgetCmaDetailsContent {
    if (json == null) {
        return json;
    }
    return {
        
        'artifactId': json['artifactId'] == null ? undefined : json['artifactId'],
        'cmaId': json['cmaId'],
    };
}

export function ArtifactWidgetCmaDetailsContentToJSON(json: any): ArtifactWidgetCmaDetailsContent {
    return ArtifactWidgetCmaDetailsContentToJSONTyped(json, false);
}

export function ArtifactWidgetCmaDetailsContentToJSONTyped(value?: ArtifactWidgetCmaDetailsContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'artifactId': value['artifactId'],
        'cmaId': value['cmaId'],
    };
}

